import { Box, Select, Text } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import Roadmap from '../../../components/V2/Roadmap/Roadmap';
import { useUser } from '../../../hooks/V2/useUser';
import { useAllCourses, usePublishedItems } from '../../../hooks/V2/useCourse';
import { useAssessmentToken } from '../../../context/AssessmentTokenContext';
import { useSelectedCourse } from '../../../context/SelectedCourseContext';

const RoadmapPage = () => {
	// const [selectedCourse, setSelectedCourse] = React.useState('');
	const { selectedCourse, setSelectedCourse } = useSelectedCourse();

	const { data: publishedItems, refetch: refetchPublishedItems } = usePublishedItems(selectedCourse?.course?._id);
	const [roadmapPublishedItem, setRoadmapPublishedItem] = React.useState<any>();
	const { data: allCourses } = useAllCourses();

	const { data: user } = useUser();
	const [options, setOptions] = React.useState<
		{
			label: string;
			value: string;
		}[]
	>([]);

	useEffect(() => {
		if (!allCourses) {
			return;
		}
		const formattedData = allCourses
			// @ts-ignore
			?.filter(course => course.isActive)
			.map(course => {
				return {
					label: course.name,
					value: course._id,
					course,
				};
			});
		setOptions(formattedData);
		// add first course with isActive true to selectedCourse
		// if (formattedData.length > 0) {
		// 	setSelectedCourse(formattedData[1]);
		// }
	}, [allCourses]);
	useEffect(() => {
		// filter first published item of type Roadmap
		if (!publishedItems) return;
		const roadmap = publishedItems.find(item => item.entityType === 'Roadmap');
		// @ts-ignore
		setRoadmapPublishedItem(roadmap);
	}, [publishedItems]);

	useEffect(() => {
		if (selectedCourse) {
			refetchPublishedItems();
		}
	}, [selectedCourse, refetchPublishedItems]);

	return (
		<Box p="16px" minH="100%" bg="#F2F6FF">
			<Box display={{ md: 'flex' }} alignItems="center" gap="4px">
				<Box mt="4px" display={{ md: 'none' }}>
					{allCourses && allCourses.length > 1 && (
						<Select
							height={'43px'}
							borderRadius={'8px'}
							borderColor="#CCC"
							bg="white"
							_focus={{
								outline: 'none',
							}}
							value={selectedCourse?.value}
							onChange={e => {
								if (!allCourses) {
									return;
								}
								setSelectedCourse(
									allCourses
										?.filter(c => c._id === e.target.value)
										.map(course => {
											return {
												label: course.name,
												value: course._id,
												course: course,
											};
										})[0],
								);
							}}
							fontWeight={600}
							fontSize={'16px'}
							lineHeight={'20px'}
							_active={{
								outline: 'none',
							}}
						>
							{options.map(option => (
								<option key={option.value} value={option.value}>
									{option.label}
								</option>
							))}
						</Select>
					)}
				</Box>
			</Box>
			<Box mt="16px" h="full">
				<Roadmap roadmapPublishedItem={roadmapPublishedItem} />
			</Box>
		</Box>
	);
};

export default RoadmapPage;
